module.exports = __webpack_public_path__ + "static/img/logo-pj-transparente-blanco.7f73976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-pj-transparente-blanco.png
// module id = a9y4
// module chunks = 2